import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VersionDirective } from '../../../core/directive/version.directive';
import { VersionService } from '../../../core/service/version.service';

@Component({
  selector: 'app-bottom-bar',
  standalone: true,
  imports: [RouterModule, VersionDirective],
  templateUrl: './bottom-bar.component.html',
  styleUrl: './bottom-bar.component.scss'
})
export class BottomBarComponent {
    constructor(public versionService: VersionService){

    }
}
